import React from 'react';
import {
  Container,
  Box,
  Breadcrumbs,
  Typography,
  Paper,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import { Link } from 'gatsby-theme-material-ui';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { TrainersList } from '../trainers-list/trainers-list';

const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    paper: {
      padding: spacing(4, 6),
    },
  })
);

export const TrainersListviewDesktop: React.FC = () => {
  const classes = useStyles();
  return (
    <Container maxWidth="lg">
      <Box mt={5} mb={5}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link color="inherit" to="/">
            Main
          </Link>
          <Typography color="textPrimary">Trainers</Typography>
        </Breadcrumbs>
      </Box>
      <Paper className={classes.paper}>
        <Typography component="h1" variant="h5">
          Find Your Personal Trainer
        </Typography>
        <Box mt={3} />
        <TrainersList />
      </Paper>
      <Box mt={5} />
    </Container>
  );
};
